$(function () {
    var topSwiper = new Swiper('.sip-trunking-top-swiper', {
        spaceBetween: 30,
        autoplay: 2000,
        slidesPerView: 3,
        // Responsive breakpoints
        breakpoints: {
            991: {
                slidesPerView: 2
            },
        },
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        loop: true,
        grabCursor: true
    });

    $('.slider-btn').click(function (e) {
        e.preventDefault();
        var $container = $(this).siblings('.call-plan-values-columns');
        var scrollOffset;

        if ($(this).hasClass('slider-prev-btn')) {
            scrollOffset = ($container.scrollLeft() - $container.width()) + 'px';
        } else {
            scrollOffset = ($container.scrollLeft() + $container.width()) + 'px';
        }

        $container.animate({scrollLeft: scrollOffset}, 200);
    });

    var pricingSwiper = new Swiper('.sip-trunking-call-rates-plans .swiper-container', {
        slidesPerView: 2,
        // Responsive breakpoints
        breakpoints: {
            // when window width is <=
            767: {
                slidesPerView: 1,
                initialSlide: 0,
            }
        },
        nextButton: '.sip-trunking-call-rates-plans .swiper-button-next',
        prevButton: '.sip-trunking-call-rates-plans .swiper-button-prev',
        grabCursor: true
    });

    $(window).on('windowResizeBreakpointChanged', function () {
        topSwiper.update();
        pricingSwiper.update();
    });

    var advancedFunctionalityIconSlider = new Swiper('.advanced-functionality-icon-slider-block .swiper-container', {
        autoplay: 2000,
        pagination: '.advanced-functionality-block .swiper-pagination',
        paginationClickable: true,
        nextButton: '.advanced-functionality-block .swiper-button-next',
        prevButton: '.advanced-functionality-block .swiper-button-prev',
        loop: true,
        grabCursor: true,
        onSlideChangeStart: function () {
            if (advancedFunctionalityTextSlider && advancedFunctionalityIconSlider) {
                advancedFunctionalityTextSlider.slideTo(advancedFunctionalityIconSlider.activeIndex);
            }
        }
    });
    var advancedFunctionalityTextSlider = new Swiper('.advanced-functionality-text-slider-block .swiper-container', {
        // autoplay: 2000,
        // pagination: '.advanced-functionality-block .swiper-pagination',
        // paginationClickable: true,
        // nextButton: '.advanced-functionality-block .swiper-button-next',
        // prevButton: '.advanced-functionality-block .swiper-button-prev',
        loop: true,
        simulateTouch: false
        // grabCursor: true,
        // onSlideChangeStart: function () {
        //     console.log('text');
        //     if (advancedFunctionalityIconSlider && advancedFunctionalityTextSlider) {
        //         advancedFunctionalityIconSlider.slideTo(advancedFunctionalityTextSlider.activeIndex, 500, false);
        //     }
        // }
    });
});